module.exports = __webpack_public_path__ + "img/direct-costs.218dd331.png";